var React = require('react');

function StarHalf (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"star-half","transform":"translate(1 1)"},[React.createElement("path",{"id":"Path_10371","data-name":"Path 10371","d":"M59.851,57.947H49.158L45.926,48l-3.233,9.947H32l8.7,5.968-3.357,9.947,8.579-6.217L54.5,73.862l-3.357-9.947Z","transform":"translate(-32 -48)","fill":"none","stroke":"#926ff9","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_10372","data-name":"Path 10372","d":"M45.926,48V67.645l-8.579,6.217L40.7,63.915,32,57.947H42.693Z","transform":"translate(-32 -48)","fill":"#926ff9","key":1})]));
}

StarHalf.defaultProps = {"width":"29.851","height":"27.862","viewBox":"0 0 29.851 27.862"};

module.exports = StarHalf;

StarHalf.default = StarHalf;
